module.exports = __webpack_public_path__ + "img/ideas-new.c2b9f37a.svg";